import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import { useSubmitRiskApprovalMutation } from '@twisto/api-graphql'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { FlowFormSubmitButton } from '@twisto/flow-views/components'
import { BigTwistoIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import { RiskApprovedStepLimitPaper } from './risk-approved-step-limit-paper'
import * as styles from './risk-approved-step.styles'

export const RiskApprovedStep = () => {
  const { flow, sessionId } = useFlow<'RiskApprovedStep'>()
  const [submit] = useSubmitRiskApprovalMutation({
    variables: {
      auth: {
        sessionId,
      },
    },
  })
  const { paymentsLimit, installmentsLimit } = flow.currentStep

  return (
    <>
      <Headline css={styles.header}>
        <HeadlineIcon>
          <BigTwistoIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.riskApprovedStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.riskApprovedStep.subtitle" />
        </HeadlineSubtitle>
      </Headline>
      <div css={styles.limitContainer}>
        <RiskApprovedStepLimitPaper
          currency={paymentsLimit.currency}
          subtitle={<Trans id="flow.riskApprovedStep.paymentsLimit.subtitle" />}
          title={<Trans id="flow.riskApprovedStep.paymentsLimit.title" />}
          value={paymentsLimit.value}
        />
        {!isNil(installmentsLimit) && (
          <RiskApprovedStepLimitPaper
            currency={installmentsLimit.currency}
            subtitle={
              <Trans id="flow.riskApprovedStep.installmentsLimit.subtitle" />
            }
            title={<Trans id="flow.riskApprovedStep.installmentsLimit.title" />}
            value={installmentsLimit.value}
          />
        )}
      </div>

      <FlowFormSubmitButton onSubmit={submit} />
    </>
  )
}
